<template>
    <v-dialog v-model="load" :max-width="tamModal" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
        persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="'Nueva Inspección'"></span>
            </v-card-title>
            <v-card-text>
                <v-form ref="form" :lazy-validation="false">
                    <v-container fluid grid-list-sm>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Asegurado" color="textbox" v-model="obModal.asegurado" outlined dense disabled />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Placa" color="textbox" v-model="obModal.placa" outlined dense disabled />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Marca" color="textbox" v-model="obModal.marca" outlined dense disabled />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Modelo" color="textbox" v-model="obModal.modelo" outlined dense disabled />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Color" color="textbox" v-model="obModal.color" outlined dense disabled />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Año" color="textbox" v-model="obModal.anio" outlined dense disabled />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Valor Asegurado" color="textbox" v-model="obModal.valorAsegurado" outlined dense disabled />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4" class="mb-4" v-for="(v,k) in _.get(listGeneral,'listInstruccionFoto',[])" :key="k">
                                <v-btn color="white" width="270" height="100" dark @click="cargar(v)" text>
                                    <div class="box text-center" v-if="v.check">
                                        <v-tooltip top color="transparent">
                                            <template v-slot:activator="{ on }">
                                                <img :src="v.iconoCheck"  alt="Instrucción Foto" v-on="on">
                                                <input type="file" style="display: none" :id="_.camelCase(v.instruccion)" accept="image/jpeg, image/png" @change="onFilePicked($event,v)"/>
                                            </template>
                                            <div class="box-tooltip text-center">
                                                <img :src="v.base64"/>
                                            </div>
                                        </v-tooltip>
                                    </div>
                                    <div class="box text-center" v-else>
                                        <v-tooltip bottom color="primary">
                                            <template v-slot:activator="{ on }">
                                                <img :src="v.icono"  alt="Instrucción Foto" v-on="on">
                                                <input type="file" style="display: none" :id="_.camelCase(v.instruccion)" accept="image/jpeg, image/png" @change="onFilePicked($event,v)"/>
                                            </template>
                                            <span>Dar Clic Para Subir Foto.</span>
                                        </v-tooltip>
                                    </div>
                                </v-btn>
                            </v-col>
                            <v-col >
                                <div class="text-right" style="margin-top:24% !important">
                                    <v-btn outlined rounded color="danger" class="mr-1" @click="close">Cancelar</v-btn>
                                    <v-btn rounded dark color="primary" @click="guardar" :disabled="disabled">Guardar</v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalCargaFotoInspeccionComponent',
        props:{
            load:{ type: Boolean, default: false},
            listGeneral:{ type: Object, default:{} },
            obForm:{ type: Object, default:{} }
        },
        inject:['close'],
        data: () => ({
            obModal:{

            }
        }),
        created(){
            this.$set(this,'obModal',this.obForm);
        },
        watch:{
            load(val){
                    this.$set(this,'obModal',{});
                if(val){
                    this.$set(this,'obModal',this.obForm);
                }
            }
        },
        computed:{
            disabled(){
                return (_.size(_.get(this.listGeneral,'listFotoInspeccion',[]))) < (_.size(_.get(this.listGeneral,'listInstruccionFoto',[]))) ? true : false;
            }
        },
        methods:{
            cargar(objeto){
                var index = _.findIndex(this.listGeneral.listInstruccionFoto,{'index':objeto.index});
                var input = document.getElementById(_.camelCase(objeto.instruccion));
                if(input)
                    input.click();
            },
            onFilePicked (e,objeto) {
                try {
                    var index = _.findIndex(this.listGeneral.listFotoInspeccion,{'index':objeto.index});
                    var name = '';
                    var band = false;

                    if(index < 0)
                        index = _.size(this.listGeneral.listFotoInspeccion);

                    var files = e.target.files
                    if(_.isUndefined(files[0])) throw mensajeEstandar.archivo;
                    if(files[0].name.lastIndexOf('.') <= 0) throw  mensajeEstandar.archivo;
                                 
                    if(_.includes(files[0].name,'.png')){ band = true; name = `${objeto.idInstruccionFoto}.png` }
                    if(_.includes(files[0].name,'.jpg')) { band = true; name = `${objeto.idInstruccionFoto}.jpg` }
                    if(_.includes(files[0].name,'.jpeg')) { band = true; name = `${objeto.idInstruccionFoto}.jpeg` }
                    
                    if(!band) throw mensajeEstandar.archivo;

                        var fr = new FileReader ()
                        fr.readAsDataURL(files[0])
                        fr.addEventListener('load', () => {
                            _.set(objeto,'base64',fr.result);
                            _.set(objeto,'nameFile',name);
                            objeto.check   = true;
                            this.$set(this.listGeneral.listFotoInspeccion,index,objeto);
                            this.$forceUpdate();
                        })

                } catch (error) {
                    mensajesAlerta(error,'I');
                }
		    },
            guardar(){
                try {
                    if(_.size(_.get(this.listGeneral,'listFotoInspeccion',[])) == 0) throw 'Debe subir todas las fotos señaladas.';
                    if((_.size(_.get(this.listGeneral,'listFotoInspeccion',[]))) < (_.size(_.get(this.listGeneral,'listInstruccionFoto',[])))) throw 'Debe subir todas las fotos señaladas.'; 

                        var keys = [ 'idVehiculo','idTipoInspeccion','idCertificado','idPoliza','idOrdenInspeccion','idCliente','idSeguro','idEstado'];
                        var keysList = [ 'idInstruccionFoto','nameFile','base64','idEstado' ];
                        var error = 'E';

                        var objeto = _.merge({},
                                             _.pick(this.obModal,keys),
                                             {
                                                opcion:'UOA',
                                                listFotoInspeccion: _.map(_.cloneDeep(this.listGeneral.listFotoInspeccion),_.partialRight(_.pick,keysList))
                                             });

                        axios.post(`${BASE_URI}administrador/orden-inspeccion/insertarOrdenAgendada`,objeto)
                             .then((r)=>{
                                 if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                 if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); };
                                    mensajeAlertaTiempo(r.data.mensaje,'S');
                                    this.close();
                             })
                             .catch((ex)=>{
                                 mensajesAlerta(ex,error);
                             });

                } catch (e) {
                    mensajesAlerta(e,error);
                }
            }
        }
    }
</script>
<style type="text/css">
    .box-tooltip{
        height: 180px;  
        align-items: center;
        display: flex;
        justify-content: center;      
    }

    .box{
        height: 80px;  
        align-items: center;
        display: flex;
        justify-content: center;      
    }

    .box > img{
        max-width: 100%;
        max-height: 100%;
    }

    .box-tooltip > img{
        max-width: 100%;
        max-height: 100%;
    }
</style>